import { Component, Input } from '@angular/core';
import { MatMenuItem } from "@angular/material/menu";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { NgForOf, NgIf } from "@angular/common";
import { ProcessingStepCount } from "@managers/case.manager";

@Component({
    selector: 'lex-processing-item',
    imports: [
        MatMenuItem,
        MatProgressBar,
        MatProgressSpinner,
        NgForOf,
        NgIf
    ],
    templateUrl: './processing-item.component.html'
})
export class ProcessingItemComponent {
	@Input() public item: ProcessingStepCount;
}
